<template>
  <a
    class="wa-float"
    :href="contact.whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp (opens WhatsApp)"
  >
    <WhatsAppIcon class="wa-float-icon" />
    <span class="wa-float-label">Chat on WhatsApp</span>
  </a>
</template>

<script>
import WhatsAppIcon from "@/components/graphics/WhatsAppIcon.vue";
import contact from "@/config/contact";

export default {
  name: "WhatsAppButton",
  components: { WhatsAppIcon },
  data: () => ({ contact }),
};
</script>
